import { Colors, Metrics, Typography } from "../../resources";
import { Pressable, StyleSheet, Text, View } from "react-native";
import React, { useState } from "react";

interface IProps {
  text: string;
  style: any;
  children: JSX.Element;
}

const SAbsoluteTooltip: React.FC<IProps> = ({ text, style, children }) => {
  const [hover, setHover] = useState<boolean>(false);

  const onHoverIn = () => setHover(true);
  const onHoverOut = () => setHover(false);

  return (
    <View style={style}>
      <Pressable
        style={styles.container}
        onMouseEnter={onHoverIn}
        onMouseLeave={onHoverOut}
      >
        {children}
      </Pressable>
      {hover ? (
        <View style={styles.modal}>
          <Text style={styles.text}>Safety Threshold</Text>
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  modal: {
    position: "absolute",
    top: 10,
    left: 0,
    backgroundColor: Colors.midnight,
    padding: 12,
    flex: 1,
    borderRadius: 4,
    shadowColor: Colors.midnight80,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  text: {
    ...Typography.bodyTitle,
    color: Colors.white,
  },
});

export default SAbsoluteTooltip;
